import { render, staticRenderFns } from "./FudaoStudentEndInviteDialog.vue?vue&type=template&id=b397611a&scoped=true&"
import script from "./FudaoStudentEndInviteDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoStudentEndInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b397611a",
  null
  
)

export default component.exports